<template>
  <article class="user_view">
    <left-menu/>
    <select-device @cancel="onCancel" :typeSelection="'multiple'" :companies="this.selectedCompany" @select="onSelect" v-if="showModal"/>
    <section class="new_user">
      <div @click="$router.push({ name: 'Coordinators' })" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <section class="new_user__form">
        <h1> Editar coordinador</h1>
        <div class="new_user__form--input-sec">
          <div class="form_input">
            <label>Nombre*</label>
            <input v-model="user.name" placeholder="Nombre"/>
          </div>
          <div class="form_input">
            <label>Apellido*</label>
            <input v-model="user.lastName" placeholder="Apellido"/>
          </div>
          <div class="form_input">
            <label>Número de cédula*</label>
            <input v-model="user.cc" type="number" @input="equals?changeID():''" placeholder="Número de cédula"/>
          </div>
          <div class="form_input">
            <label>ID Carné</label>
            <input v-model="user.id" type="number" @change="equals=false" placeholder="Id carné"/>
          </div>
          <div class="form_input">
            <label>Correo electrónico *</label>
            <input v-model="user.email" @input="checkMailAcepted" type="text" placeholder="Correo electrónico"/>
          </div>
          <div class="form_input">
            <label>Empresa * <small>{{(user.company).length}} Empresas seleccionadas</small></label>
            <input style="cursor: pointer;" v-model="user.company" @click="showModal = true" placeholder="Seleccione empresa"/>
          </div> 
        </div>
        <div style="margin-bottom:10px">
          <h5  class="login__sect-right__form--error">{{errorMessage}}</h5> 
        </div>
        <button class="secondary_button" @click.prevent="editCoordinator" :class="{'click':isCreated,'active': isComplete()}" :style="{width: '160px', height:'46px'}">GUARDAR</button>
      </section>
    </section>
  </article>
</template>

<script>

export default {
  data(){
    return{
      isCreated:false,
      errorMessage:"",
      user: {
        name: '',
        lastName: '',
        cc: '',
        id: '',
        email: '',
        company: [],
      },
      showModal: false,
      selectedCompany:[],
      coordinator:{},
      equals:false,
      isInError: false,
    }
  },
  methods:{
      editCoordinator(){
        this.isCreated=true;  
        setTimeout(() => { this.isCreated=false; }, 200);
        const customActions={
            edit: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'PATCH'}                   
        };
        this.resource= this.$resource('coordinators/dashboard/' + this.$route.params.id,{},customActions);
        this.resource.edit({
          "user": {"id_card": this.user.cc, "card_company": this.user.id,"name": this.user.name, "last_name": this.user.lastName},
          email: this.user.email,
          company: this.selectedCompany
          })
        .then(function(data){
          this.$router.push({ name: 'Coordinators' });
        }).catch(function(err){
           var errorlog=Object.keys(JSON.parse(err.bodyText).errors)[0];
          if (JSON.parse(err.bodyText).errors[errorlog][0]){
            if(JSON.parse(err.bodyText).errors[errorlog][0]=="has already been taken"){
              this.errorMessage="El número de cedula ya se encuentra registrado"             
            }else{
              this.errorMessage="Ha ocurrido un error en la edición, intentelo de nuevo"
            }
          }else{
            this.errorMessage="Ha ocurrido un error en la edición, intentelo de nuevo"
          }
        });
      },
      isComplete(){
        if(this.user.name!='' && this.user.lastName!='' && this.user.cc!='' && this.user.email!='' && this.user.id!=''){
          return true;
        }
      },
      changeID(){
        this.user.id=this.user.cc;
      },
      onCancel(value){
        this.showModal = value;
      },
      onSelect(value){
        this.user.company = [];
        this.selectedCompany = [];
        value.forEach(element => {
          this.user.company.push(element.name);
          this.selectedCompany.push(element.id);
        });
        this.showModal = false;
        
      },
      checkMailAcepted(){
        if(!this.isMailAcepted){
          this.isInError=true;
        }
        else{
          this.isInError=false
        }
      },
  },
  created(){
      const customActionsGet={
        get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
      };
      this.$resource('coordinators/dashboard/'+ this.$route.params.id,{},customActionsGet).get()
      .then(function(data){

        this.coordinator=data.body;
        this.user.name = this.coordinator.user.name;
        this.user.lastName = this.coordinator.user.last_name;
        this.user.cc = this.coordinator.user.id_card;
        this.user.id = this.coordinator.user.card_company;
        this.user.email = this.coordinator.user.email;
        this.coordinator.company.forEach(element => {
          this.user.company.push(element.name);
          this.selectedCompany.push(element.id);
        });
        if(this.user.cc==this.user.id){
          this.equals=true;
        }
      });

      
  },
  computed:{
      isMailAcepted(){
        var regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(this.user.email) ? true : false;
      }
    },
  
}
</script>


// WEBPACK FOOTER //
// src/components/pages/EditCoordinator.vue